<template>
  <b-container>
    <b-row class="justify-content-center my-5">
      <b-col cols="11" lg="6" class="sg-rounded-container">
        <b-row class="justify-content-center">
          <b-col cols="6" class="p-3">
            <b-img
              :src="require('@/assets/img/guider/sad-confused.png')"
              fluid
            />
          </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col cols="11">
            <h4>Forgot Your Password?</h4>
          </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col cols="10" lg="6">
            <b-form>
              <b-form-row class="mt-3">
                <b-col>
                  <b-input-group
                    label="Email"
                    label-for="input-email"
                    label-sr-only
                  >
                    <b-form-input
                      id="input-email"
                      placeholder="Email"
                      v-model="user.email"
                      type="email"
                    />
                  </b-input-group>
                </b-col>
              </b-form-row>
              <b-form-row class="mt-3">
                <b-col>
                  <b-input-group
                    label="Phone"
                    label-for="input-phone"
                    label-sr-only
                  >
                    <b-form-input
                      id="input-phone"
                      placeholder="Phone"
                      v-model="user.phone"
                      type="number"
                    />
                  </b-input-group>
                </b-col>
              </b-form-row>

              <b-form-row class="mt-4 justify-content-center">
                <b-col cols="6">
                  <b-button variant="success" block @click="resetPassword">
                    Submit
                  </b-button>
                </b-col>
              </b-form-row>
            </b-form>
          </b-col>
        </b-row>

        <b-row class="mt-3 justify-content-center">
          <b-col cols="11">
            <ul>
              <li>Masukkan email yang anda gunakan untuk mendaftar.</li>
              <li>Kami akan mengirimkan kode verifikasi untuk mengatur ulang kata sandi.</li>
              <li>Mohon Mengisi Nomor Telepon, Nomor Telepon sebagai keamanan akun Anda.</li>
            </ul>
          </b-col>
        </b-row>

        <b-row class="mt-3" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// external dependencies
import swal from 'sweetalert'

// custom component
import Authentication from '@/api/AuthenticationAPI'

// api call

export default {
  name: 'ResetPassword',
  /* components: {
  }, */
  data () {
    return {
      user: {
        email: '',
        phone: ''
      },
      reset_button_state: true,
      errors: []
    }
  },
  beforeCreate: function () {
    if (this.$session.exists()) {
      this.$router.push({ name: 'PageNotFound' })
    }
  },
  methods: {
    // PREREQUISITES
    isEmptyOrSpaces: function (str) {
      return str === null || str.match(/^ *$/) !== null
    },
    // END PREREQUISITES

    // HTTP REQUEST
    resetPassword: async function () {
      this.reset_button_state = true
      this.errors = []

      if (this.isEmptyOrSpaces(this.user.email)) this.errors.push('Email is Required.')

      if (this.errors.length) {
        swal({
          title: 'Please check your input.',
          text: this.errors[0],
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })

        this.reset_button_state = false
      } else {
        try {
          await Authentication.ResetPassword(this.user)
          swal({
            title: 'Your Password has been reset!',
            text: `Please check your email`,
            icon: 'success',
            button: {
              text: 'Ok'
            }
          })

          setTimeout(() => {
            this.$router.go()
          }, 2000)
        } catch (error) {
          let msg = error.response.data

          swal({
            title: 'Email not found',
            text: msg,
            icon: 'error',
            button: {
              text: 'Ok'
            }
          })

          this.reset_button_state = false
        }
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.form-corporate {
  border-radius: 15px;
  background-color: #fafafa;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue